import React from 'react'
import { IconButtonBackArrow } from 'components/atoms/icons'
import { Button } from '@material-ui/core'
import { useStyles } from './styles'

const BackButton = ({ previousUrl }) => {
  const classes = useStyles()

  return (
    <Button
      className={classes.backButton}
      href={previousUrl}
      startIcon={<IconButtonBackArrow />}
    >
      Back
    </Button>
  )
}

export default BackButton
